import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useRecoilValue } from 'recoil';

import { Collection } from 'Components/Collection';
import { CollectionFilters } from 'Components/CollectionFiIters';
import { initPlugState } from 'lib/recoil/atoms';
import { myFilteredCollectionsState } from 'lib/recoil/selectors';

export const Collections = () => {
	const { isConnected } = useRecoilValue(initPlugState);
	const myCollections = useRecoilValue(myFilteredCollectionsState);

	return (
		<>
			{isConnected ? (
				<>
					<CollectionFilters />
					<Divider
						sx={{
							width: '100%'
						}}
					/>
					{myCollections.map((collection, idx) => (
						<Collection
							key={collection.canisterId}
							collection={collection}
							isLastCollection={myCollections.length === idx + 1}
						/>
					))}
				</>
			) : (
				<Typography variant='h4' fontWeight='bold'>
					Connect your wallet
				</Typography>
			)}
		</>
	);
};
